// Whether there is anything worth opening the Actionstep save dialog for.
//
// A plain module rather than a helper inside the panel, so it can be tested without
// rendering anything. The original check lived inline in the component and asked only
// whether there was note text - which predated document-only tools and silently blocked
// every one of them: they set saveNote={false} and supply a document, so they pass no note
// text at all. A form that was completely filled in was told to "fill in some form data".
//
// Inline, it could only be exercised by clicking the button in a browser. That is how it
// stayed wrong across six tools.
export function hasSomethingToSave({
  saveNote = true,
  noteText = "",
  getDocuments = null,
  documents = [],
} = {}) {
  const hasNote = saveNote && Boolean(String(noteText || "").trim());
  const hasDocuments = Boolean(getDocuments) || (documents?.length || 0) > 0;
  return hasNote || hasDocuments;
}
